<script>
export default {
  props: ['url'],
  data() {
    return {
      input: this.url
    }
  },
  computed: {
    formattedUrl() {
      let formattedUrl = this.input
      if (formattedUrl != '' && !formattedUrl.startsWith('http://') && !formattedUrl.startsWith('https://')) {
        formattedUrl = 'http://' + formattedUrl
      }
      return formattedUrl
    }
  },
  render() {
    return this.$scopedSlots.default({
      inputProps: {
        value: this.formattedUrl
      },
      inputEvents: {
        focusout: e => (this.input = e.target.value)
      }
    })
  }
}
</script>
